import { gsap } from "gsap";

const pageComponents = document.querySelectorAll('section[class^=c-]');
let anchorSections = [];
let anchorsContainer = document.querySelector('.section-anchors-container');


// Helper function to get CSS properties of elements
const getPropertyValueFn = (element, cssProperty) => {
    let properyVal = window.getComputedStyle(element).getPropertyValue(cssProperty)
    return parseInt(properyVal.replace('px', ''));
}

// Loop through all page components and create anchors from the ones that have a data-title
for (let pageComp of pageComponents) {
    let pageCompTitle = pageComp.getAttribute('data-title');

    if (!!pageCompTitle) {
        anchorSections.push(pageComp);
        let pageCompID = pageCompTitle.toLowerCase().replace(/[\W_]+/g, "_");
        pageComp.setAttribute('id', pageCompID)

        //Create new anchor link 
        let newAnchor = `<a href="#${pageCompID}" class="section-anchor" style="transform:translateX(-5px); opacity:0;">${pageCompTitle}</a>`;

        //Add new anchor to anchors container el
        anchorsContainer.innerHTML += newAnchor
    }
}
let sectionAnchors = document.querySelectorAll('a.section-anchor');
if (!!sectionAnchors) {
    //Animate in all new anchors
    gsap.to(sectionAnchors, {x:0, opacity:1, stagger:0.075});

    //Click listner - add custom scroll point because sticky .header & .section-anchors-container get in the way
    for (let sectionAnchor of sectionAnchors) {
        sectionAnchor.addEventListener('click', (e) => {
            e.preventDefault();

            let activeID = sectionAnchor.getAttribute('href');
            let activeSection = document.querySelector(activeID);
            let activeSectionScrollPoint = window.scrollY + activeSection.getBoundingClientRect().top;
            let scrollOffsetAmt = anchorsContainer.offsetHeight - 1; //Adjust by 1px to make sure we land in the active container to set section anchor active class correctly
            //If scroll point is lower number than current scroll then we'll be going up, and need to account for header height
            if (activeSectionScrollPoint < window.scrollY) {
                scrollOffsetAmt += getPropertyValueFn(document.body, '--header-height');
            }
            activeSectionScrollPoint -= scrollOffsetAmt;

            window.scrollTo({
                top: activeSectionScrollPoint,
                left: 0
            });
        })
    }
}


// Highlight active section's anchor on scroll
let anchorSectionsReverse = [...anchorSections].reverse(); //Use spread operator and reverse() to get page component anchor sections in reverse order
const highlightActiveSection = () => {
    let headerPlusAnchorsContainerHeight = anchorsContainer.offsetHeight + getPropertyValueFn(document.body, '--header-height');

    for (let currentSection of anchorSectionsReverse) {
        let sectionTop = currentSection.getBoundingClientRect().top;

        if (sectionTop <= headerPlusAnchorsContainerHeight) {
            let activeID = currentSection.getAttribute('id');
            let activeAnchor = document.querySelector(`.section-anchor[href="#${activeID}"`);
            //Remove .active class from any other active anchors
            for (let sectionAnchor of sectionAnchors) {
                if (sectionAnchor.classList.contains('active') && activeAnchor !== sectionAnchor) {
                    sectionAnchor.classList.remove('active');
                }
            }
            //Add active class to new active anchor button
            activeAnchor.classList.add('active');
            
            // We have found active, so we return false to exit the loop
            return false;
        }
    }
    //No actives found, so remove active from all (like when scrolling up in the hero)
    for (let sectionAnchor of sectionAnchors) {
        if (sectionAnchor.classList.contains('active')) {
            sectionAnchor.classList.remove('active');
        }
    }
}
//Call highlightActiveSection() fn on throttled scroll
window.addEventListener('scroll', throttle(() => {
    highlightActiveSection()
}, 100))

//Scroll-x anchorsContainer to the activeAnchor position (mobile)
const scrollActiveSectionAnchor = () => {
    let activeAnchor = document.querySelector('.section-anchor.active');
    if (!!activeAnchor) {
        anchorsContainer.scrollTo({
            top: 0,
            left: (activeAnchor.offsetLeft - getPropertyValueFn(anchorsContainer, 'padding-left'))
        });
    } else {
        anchorsContainer.scrollTo({
            top: 0,
            left: 0
        });
    }
}
//Call scrollActiveSectionAnchor() fn on debounced scroll (not using throttle because of issues because scrolling-x on mobile can become erratic if fired too often)
window.addEventListener('scroll', debounce(() => {
    scrollActiveSectionAnchor()
}, 50))